export default __webpack_public_path__ + "static/media/cloud.2bec56ec.png";